module.exports = __webpack_public_path__ + "img/contact-img.b5ba6def.png";